import {updateSupplierOffer} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierOfferKeys, supplierOfferMutationKeys} from "../../../supplierOffer-keys";
import type {UpdateSupplierOfferFormPayload} from "./update-supplier-offer.schema";

export function updateSupplierOfferMutationOptions(supplierId: string, catalogItemId: string) {
  return mutationOptions({
    mutationKey: supplierOfferMutationKeys.updateSupplierOffer,
    mutationFn: (payload: UpdateSupplierOfferFormPayload) => {
      const args: Parameters<typeof updateSupplierOffer> = [supplierId, catalogItemId, payload];
      return updateSupplierOffer(...args);
    },
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierOfferKeys.detail({supplierId, catalogItemId})}),
        client.invalidateQueries({queryKey: supplierOfferKeys.lists()}),
      ]);
    },
  });
}
